import { cn } from "@/lib/utils"

// Chic, our mascot, taking the Claude news hard. A hand-built SVG (the real
// logo is a flattened PNG, so it can't be vector-edited) that mirrors the
// mascot — coral belly, round eye, beak, stick legs — with a worried brow and
// animated tears. Used for comic relief on the /claude page.
export function CryingChic({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 200 210"
      className={cn(`w-40 h-auto`, className)}
      role="img"
      aria-label="Chic the mascot, crying"
    >
      <style>{`
        @keyframes chic-drip {
          0% { transform: translateY(-4px); opacity: 0 }
          15% { opacity: 1 }
          75% { opacity: 1 }
          100% { transform: translateY(30px); opacity: 0 }
        }
        .chic-drop { transform-box: fill-box; transform-origin: center;
          animation: chic-drip 2.2s ease-in infinite }
        .chic-drop-2 { animation-delay: 1.1s }
      `}</style>
      {/* body */}
      <path
        d="M58 46 C92 18 138 26 148 64 L172 74 L148 86 C156 128 150 158 116 170 C78 184 40 168 38 122 C32 82 34 60 58 46 Z"
        fill="#fff"
        stroke="#23272f"
        strokeWidth="9"
        strokeLinejoin="round"
      />
      {/* coral belly */}
      <path
        d="M52 96 C92 92 112 124 102 156 C74 172 46 156 44 122 C44 110 46 102 52 96 Z"
        fill="#FF7F66"
      />
      {/* eye */}
      <circle cx="112" cy="74" r="11" fill="#23272f" />
      {/* worried brow */}
      <path
        d="M99 60 Q112 52 126 61"
        stroke="#23272f"
        strokeWidth="5"
        strokeLinecap="round"
        fill="none"
      />
      {/* welling tear streaming from the eye */}
      <path
        d="M110 87 C118 96 118 113 110 113 C102 113 102 96 110 87 Z"
        fill="#7CC4E8"
      />
      {/* falling droplets */}
      <path
        className="chic-drop"
        d="M103 124 C109 131 109 144 103 144 C97 144 97 131 103 124 Z"
        fill="#7CC4E8"
      />
      <path
        className="chic-drop chic-drop-2"
        d="M120 120 C125 126 125 137 120 137 C115 137 115 126 120 120 Z"
        fill="#7CC4E8"
      />
      {/* legs */}
      <path
        d="M96 168 V196 M116 168 V196"
        stroke="#23272f"
        strokeWidth="7"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  )
}
